import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
import store from '~/store'
import Meta from 'vue-meta'

// const WP_Route = window.WP_Route || {};

Vue.use(VueRouter)
Vue.use(Meta, {
  keyName: 'metaInfo', // the component option name that vue-meta looks for meta info on.
  attribute: 'data-vm', // the attribute name vue-meta adds to the tags it observes
  tagIDKeyName: 'vmid' // the property name that vue-meta uses to determine whether to overwrite or append a tag
})

/**
 * WP_INITIALIZEをセット
 */
let WP_INITIALIZE = window.WP_INITIALIZE || {};

async function syncWPRoute(to, from, next) {
  if(WP_INITIALIZE) {
    store.commit('route/SAVE_INFO', Object.assign({}, WP_INITIALIZE));

    /**
     * トップページに表示する各項目を、初回アクセス時にセッション終了まで保存
     */
    // top information
    if(WP_INITIALIZE.top_info) {
      store.commit('route/SAVE_INFO', {
        top_info: WP_INITIALIZE.top_info
      });
    }

    /**
     * destination list はいつもほしい
     */
    if(WP_INITIALIZE.destination_list) {
      store.commit('route/SAVE_INFO', {
        destination_list: WP_INITIALIZE.destination_list
      });

    }



    WP_INITIALIZE = '';
  } else {
    const pagePath = to.path.replace(/^\//, '');
    await store.dispatch('route/fetchInfo', pagePath);
  }

  next();
}


const router = new VueRouter({
  mode: 'history',
  base: '/',
  routes,
  scrollBehavior: (to, from, savedPosition) => {
    /**
     * 動的コンポーネント描画前に遷移が完了しているため、元の場所に戻らない
     */
    // console.log('router', this);
    // console.log(window)
    const selector = location.hash
    return selector ? { selector } : { x: 0, y: 0 }
    // return !savedPosition ? { x: 0, y: 0 } : savedPosition;
  },
})

router.beforeEach((to, from, next) => {
  store.commit('menu/HIDE')
  syncWPRoute(to, from, next)
});
router.afterEach();

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js